import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarIndicatorDirective } from './avatar-indicator.directive';

@NgModule({
  declarations: [
    AvatarIndicatorDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AvatarIndicatorDirective
  ]
})
export class AvatarIndicatorModule { }
